import React from 'react'
import Image from 'next/image'

export default function Logo() {
  return (
    <Image
      fill={true}
      src="./images/kiotfinance_logo.webp"
      alt="Phần mềm quản lý bán hàng KiotViet"
    />
  )
}
